if (!customElements.get('theme-documentation-tab')) {
  customElements.define(
    'theme-documentation-tab',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll('[data-theme-documentation-target]');
        this.contents = this.querySelectorAll('[data-theme-documentation-content]');

        this.init();
      }

      init() {
        this.tabs.forEach(tab => {
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            if (tab.classList.contains('active')) return;

            const target = tab.getAttribute("data-theme-documentation-target");
            const targetElement = this.querySelector(`#${target}`);

            if (targetElement) {
              // Get the scroll top position of the target element
              const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;

              // Scroll to the target position
              window.scroll({
                top: targetPosition,
                behavior: 'smooth'
              });

              // Execute the original logic after scrolling is complete
              const handleScrollEnd = () => {
                // Check if the current scroll position matches the target
                if (Math.abs(window.scrollY - targetPosition) <= 1) {
                  window.removeEventListener('scroll', handleScrollEnd);

                  if(tab.hasAttribute('data-theme-documentation-sub-button')) return;
                  this.resetTabs(this.tabs);
                  this.resetTabs(this.contents);
                  this.tabs.forEach(tab => {
                    const accordionTab = tab.querySelector('accordion-item');
                    if(!accordionTab || accordionTab.getAttribute('aria-expanded') === 'false') return;
                    accordionTab?.setAttribute('aria-expanded', 'false');
                  });

                  tab.classList.add('active');
                  targetElement.classList.add('active');
                  tab.querySelector('accordion-item')?.setAttribute('aria-expanded', 'true');
                }
              };

              window.addEventListener('scroll', handleScrollEnd);
            }
          });
        });
      }

      resetTabs(items) {
        return items.forEach(item => item.classList.remove('active'));
      }
    }
  );
}

if(!customElements.get('accordion-item')) {
  customElements.define(
    'accordion-item',
    class AccordionComponents extends HTMLElement {
      constructor() {
        super();
        this.isAnimating = false;
        this.content = this.querySelector('.js-accordion-content');
        this.observeAttributeChanges();
      }

      connectedCallback() {
        this.addEventListener('click', (event) => {
          if (this.content.contains(event.target) || this.isAnimating) return;
          this.expanded = this.getAttribute('aria-expanded');
          this.setAttribute('aria-expanded', (this.expanded === 'false').toString());
        });
      }

      observeAttributeChanges() {
        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
              (this.getAttribute('aria-expanded') === 'false')
                ? this.runAnimationFrame(this.content, 'slideUp')
                : this.runAnimationFrame(this.content, 'slideDown');
            }
          }
        });

        observer.observe(this, { attributes: true, attributeOldValue: true });
      }

      runAnimationFrame(element, action, duration = 400) {
        if (this.isAnimating) return;
        this.isAnimating = true;
        const startTime = performance.now();
        const animate = (time) => {
          const elapsed = time - startTime;

          action === 'slideDown' ? this.slideDown(element, elapsed, duration) : this.slideUp(element, elapsed, duration);
          if (elapsed > duration) {
            this.isAnimating = false;
            return;
          };
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }

      slideUp(element, elapsed, duration = 400) {
        const progress = (elapsed - 40) / (duration - 40);
        const height = element.scrollHeight * (1 - progress);

        element.style.overflow = 'hidden';
        if(elapsed > 0)
          element.style.height = `${height}px`;

        if(elapsed > duration) {
          element.style.display = 'none';
          element.style.height = '0';
        } else {
          element.style.display = 'block';
        }
      }

      slideDown(element, elapsed, duration = 400) {
        if(elapsed < 40) {
          element.style.height = '0';
          element.style.overflow = 'hidden';
          element.style.display = 'block';
        }

        if(elapsed > 40 && elapsed < 400) {
          const progress = (elapsed - 40) / (duration - 40);
          const height = element.scrollHeight * progress;
          element.style.height = `${height}px`;
        }
      }
    }
  );
}